/* "If bought separately" label (Will/Bruce 10/21, 16 CFR 233.4): for sets whose compare-at is the sum of their live singles
   (product tag compare-basis-singles → window.zbmValueSets, set in layout/theme.liquid), the struck-through "was" price is replaced by
   "$190.00 if bought separately" (not struck), the card "Sale" badge reads "Set saving" and the PDP "Save 23%" reads "Save 23% vs. singles".
   Untagged products are untouched. Re-runs when the PDP variant, cart drawer, cart page or search re-render. */
(function () {
  'use strict';
  var SETS = window.zbmValueSets || [];
  if (!SETS.length) return;
  var SUFFIX = ' if bought separately';
  var CARD = '.zbm-col-card, .zbm-pr-card, .zbm-fy-card, .zbm-dr-line, .zbm-dr-rec, [data-zbm-line], .zbm-cart-line, .zbm-sc-rk, .zbm-search-card, tr, li, article';
  function handleIn(el) {
    var a = el && el.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function handleFor(el) {
    var card = el.closest(CARD), pd = el.closest('[data-zbm-product]');
    if (card && (!pd || pd.contains(card) && card !== pd)) { var h = handleIn(card); if (h) return h; }
    if (pd) { var f = pd.querySelector('form[data-product-handle]'); if (f) return f.getAttribute('data-product-handle'); }
    return card ? handleIn(card) : null;
  }
  function label(el) {
    if (!el.textContent.trim() || el.getAttribute('data-zbv') === el.textContent) return;
    /* append the suffix once, after the last text node that holds an amount */
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n, last = null;
    while ((n = w.nextNode())) { if (/\d/.test(n.nodeValue) && !(n.parentElement && n.parentElement.classList.contains('zbm-dr-sr'))) last = n; }
    if (!last) return;
    if (el.textContent.indexOf(SUFFIX.trim()) === -1) last.nodeValue = last.nodeValue.replace(/\s+$/, '') + SUFFIX;
    var sr = el.querySelector('.zbm-dr-sr'); if (sr) sr.textContent = 'Value ';
    el.classList.add('zbm-was--value');
    el.setAttribute('data-zbv', el.textContent);
  }
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.zbm-was, .zbm-dr-was, .zbm-cart-was, .zbm-fy-p s'), function (el) {
      var h = handleFor(el); if (h && SETS.indexOf(h) > -1) label(el);
    });
    Array.prototype.forEach.call(document.querySelectorAll('.zbm-col-badge, .zbm-pr-badge, .zbm-pd-badges .zbm-badge'), function (b) {
      if (!/^\s*sale\s*$/i.test(b.textContent)) return;
      var h = handleFor(b); if (h && SETS.indexOf(h) > -1) b.textContent = 'Set saving';
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-zbm-save]'), function (b) {
      if (!/^Save \d+%$/.test(b.textContent.trim())) return;
      var h = handleFor(b); if (h && SETS.indexOf(h) > -1) b.textContent = b.textContent.trim() + ' vs. singles';
    });
  }
  var queued = false, obs = new MutationObserver(function () {
    if (queued) return; queued = true;
    requestAnimationFrame(function () { queued = false; obs.disconnect(); run(); obs.observe(document.body, { childList: true, subtree: true, characterData: true }); });
  });
  function boot() { run(); obs.observe(document.body, { childList: true, subtree: true, characterData: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
